<template>
  <div class="flex flex-col items-center justify-end px-16 py-8 text-white xl:px-32 xl:py-16 bg-secondary-500">
    <div class="mb-8 space-y-2 font-bold text-center xl:mb-16">
      <p class="text-3xl tracking-wider xl:text-4xl">
        099 006 4816
      </p>
      <p class="text-xl font-bold xl:text-2xl">
        RESIDENTIAL.CENTRALPATTANA.CO.TH
      </p>
    </div>

    <p class="text-xs text-justify font-extra-compressed">
      เจ้าของโครงการ บริษัท ซีพีเอ็น เรซซิเด้นซ์ จำกัด ทะเบียนบริษัทเลขที่ 0105550131420 สำนักงานแห่งใหญ่ตั้งอยู่ เลขที่ 999/9 ถนนพระราม1 แขวงปทุมวัน เขตปทุมวัน กรุงเทพมหานคร ทุนจดทะเบียน 1,000,000,000.00บาท ทุนชำระแล้ว 400,600,000.00 บาท กรรมการผู้มีอำนาจลงนาม นายปรีชา เอกคุณากูล และ เรืออากาศเอกกรี   เดชชัย  ชื่อโครงการ เอสเซ็นท์ หาดใหญ่ ที่ตั้งโครงการ ตำบลหาดใหญ่ อำเภอหาดใหญ่ จังหวัดสงขลา โฉนดที่ดินเลขที่ 315357 เลขที่ดิน 629 ตำบลหาดใหญ่ อำเภอหาดใหญ่ จังหวัดสงขลา เนื้อที่ประมาณ 3-0-34.1 ไร่ ที่ดิน ได้รับสิทธิภาระจำยอมและภาระจำยอมบางส่วน เรื่อง การใช้ถนน ทางเดิน ทางรถยนต์ ระบบไฟฟ้า ประปา โทรศัพท์ ท่อระบายน้ำ รวมทั้งสาธารณูปโภคต่าง ๆ ทั้งบนดินและใต้ดินของโฉนดที่ดินเลขที่ 2245, 32853, 32854, 32855, 262369 และ 142338  ตำบลและอำเภอเดียวกัน ที่ดินไม่มีภาระผูกพัน รูปแบบโครงการเป็นอาคารชุดสูง 36 ชั้น จำนวน 1 อาคาร รวม 666 ห้อง (เพื่อพักอาศัย 665 ห้อง และเพื่อการพาณิชย์ 1 ห้อง) อยู่ในระหว่างดำเนินการขออนุญาตต่อหน่วยงานราชการ  คาดว่าจะเริ่มก่อสร้างประมาณเดือนมกราคม 2564 และคาคว่าจะแล้วเสร็จประมาณเดือน กรกฎาคม 2566 ทั้งนี้ จะจดทะเบียนเป็นอาคารชุดเมื่อการก่อสร้างแล้วเสร็จ และผู้ซื้อจะต้องชำระเงินกองทุน ค่าใช้จ่ายส่วนกลาง ภาษีอากร และค่าธรรมเนียม ตามที่เจ้าของโครงการหรือนิติบุคคลอาคารชุดกำหนดภายใต้กฎหมายอาคารชุด ภาพทั้งหมดเป็นภาพจำลอง บรรยากาศจำลอง บริษัทฯขอสงวนสิทธิ์ในการเปลี่ยนแปลงข้อมูลรายละเอียด ราคาการตกแต่งภายใน ตามความเหมาะสมโดยไม่ต้องแจ้งให้ทราบล่วงหน้า
    </p>

    <div class="absolute inset-0 flex items-center justify-center">
      <img src="@/assets/images/logo-central-pattana.svg" alt="Central Pattana">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
}
</script>
